import { immer } from "zustand/middleware/immer";

interface CustomerAndUserState {
  customerCount: number;
  customers: any[]; // You can replace 'any' with your customer type
  userCount: number;
  users: any[];
}

interface CustomerAndUserAction {
  setCustomerCount: (count: number) => void;
  setCustomers: (customers: any[]) => void;
  clearCustomerData: () => void;
  setUserCount: (count: number) => void;
  setUsers: (users: any[]) => void;
  clearUserData: () => void;
}

export interface customerAndUserInterface
  extends CustomerAndUserState,
    CustomerAndUserAction {}

export const customerAndUserSlice = immer<customerAndUserInterface>((set) => ({
  customerCount: 0,
  customers: [],
  userCount: 0,
  users: [],

  setCustomerCount: (count) => {
    set((state) => {
      state.customerCount = count;
    });
  },

  setCustomers: (customers) => {
    set((state) => {
      state.customers = [...customers];
      state.customerCount = customers.length;
    });
  },

  clearCustomerData: () => {
    set((state) => {
      state.customerCount = 0;
      state.customers = [];
    });
  },

  setUserCount: (count) => {
    set((state) => {
      state.userCount = count;
    });
  },

  setUsers: (users) => {
    set((state) => {
      state.users = [...users];
      state.userCount = users.length;
    });
  },

  clearUserData: () => {
    set((state) => {
      state.userCount = 0;
      state.users = [];
    });
  },
}));
